/**
 * Словник: de.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_de.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Warten auf den anderen Teilnehmer...",
  connectionLost: "Verbindung verloren",
  peerLeft: "👋 Der andere Teilnehmer hat den Anruf verlassen",
  connectionError: "🚫 Verbindungsfehler",
  connectionFailedTryAgain: "🚫 Verbindung zum Server fehlgeschlagen. Bitte versuche es erneut.",
  reconnectionFailed: "🚫 Verbindung verloren. Wiederherstellung nach {attempts} Versuchen fehlgeschlagen.",
  connectionErrorWithDetails: "🚫 Verbindungsfehler: {error}",
  speakerLoud: "Laut",
  speakerEar: "Hörer",
  copyRoomId: "Raum-ID kopieren",
  share: "Teilen",
  linkCopied: "🔗 Link kopiert!",
  idCopied: "🆔 ID kopiert!",
  startMeeting: "Meeting starten",
  chooseAction: "Wählen Sie eine Aktion",
  createNewRoom: "Neuer Raum",
  scheduleCall: "Anruf planen",
  calendarOpened: "📅 Kalender erfolgreich geöffnet",
  linkCopiedToClipboard: "🔗 Link in Zwischenablage kopiert",
  enterRoomId: "Raum-ID eingeben",
  roomIdValidationError: "Raum-ID darf nur Buchstaben, Zahlen und Bindestriche enthalten",
  joinRoom: "BEITRETEN",
  termsAndPrivacyHelp: "AGB & Datenschutz | Hilfe",
  invite: "Einladen",
  mySettings: "Meine Einstellungen",
  peerSettings: "Gegenüber-Einstellungen",
  blockRemoteControl: "Fernbedienung blockieren",
  iAgreeToTerms: "Ich stimme den Service-Bedingungen zu",
  termsOfUse: "Nutzungsbedingungen",
  privacyPolicy: "Datenschutzrichtlinie",
  howToUse: "Wie man verwendet",
  termsAcceptanceRequired: "Sie müssen den Bedingungen zustimmen, um den Service zu nutzen",
  ok: "OK",
  permissionsRequired: "Berechtigungen erforderlich",
  permissionsNeededMessage: "Diese App benötigt die folgenden Berechtigungen für ordnungsgemäße Funktion:",
  permissionsNote: "Hinweis: Wenn Sie Berechtigungen in den Einstellungen ändern, startet iOS die App neu. Dies ist normales Verhalten.",
  permissionsEnableMessage: "Bitte aktivieren Sie diese Berechtigungen in Ihren Geräteeinstellungen, um fortzufahren.",
  cancel: "Abbrechen",
  openSettings: "Einstellungen öffnen",
  websocketError: "WebSocket-Fehler",
  roomFull: "Raum ist voll",
  timeExpired: "Zeit abgelaufen",
  remaining: "verbl.",
  mediaPermissionsRequired: "Videoanrufe benötigen Zugriff auf Kamera und Mikrofon. Bitte gewähren Sie die Berechtigungen in Ihrem Browser.",
  mediaPermissionsRequiredMobile: "Videoanrufe benötigen Zugriff auf Kamera und Mikrofon. Bitte gewähren Sie die Berechtigungen in den App-Einstellungen.",
  browserSettings: "Browser-Einstellungen",
  openAppSettings: "Einstellungen öffnen",
  grantPermissions: "Berechtigungen gewähren",
  permissionsNotGranted: "Berechtigungen nicht gewährt. Bitte gewähren Sie die Berechtigungen, um fortzufahren.",
  permissionRequestError: "Fehler beim Anfordern von Berechtigungen: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "Für Videoübertragung",
  microphoneDescription: "Für Audioübertragung",
  continueWithoutPermissions: "Ohne Berechtigungen fortfahren",
  mediaPermissionsRequiredFallback: "Medienberechtigungen für Videoanrufe erforderlich. Bitte gewähren Sie Berechtigungen in den Browser-Einstellungen.",
  mediaPermissionsRequiredMobileFallback: "Medienberechtigungen für Videoanrufe erforderlich. Bitte gewähren Sie Berechtigungen in den App-Einstellungen.",
  browserSettingsFallback: "Browser-Einstellungen",
  openAppSettingsFallback: "Einstellungen öffnen",
  permissionsPermanentlyDenied: "Berechtigungen dauerhaft verweigert. Bitte aktivieren Sie sie in den App-Einstellungen.",
  continueText: "Fortfahren",
  mirror: "Spiegel",
  fitContain: "Einpassen",
  fitCover: "Füllen",
  switchCamera: "Kamera",
  block: "Sperren",
  pip: "PiP",
  mic: "Mik",
  video: "Video",
  speaker: "Lautspr.",
  readyToConnect: "Bereit zu verbinden?",
  startOneOnOne: "Videoanruf starten",
  createPrivateLink: "Link in einer Sekunde bereit",
  welcomeExplainer: "Erstellen Sie einen Link und schicken Sie ihn, wem Sie möchten. Er öffnet sich auch ohne die App.",
  joinHaveLink: "Haben Sie einen Link?",
  joinFieldHint: "Link oder ID einfügen",
  roomInputInvalid: "Fügen Sie einen Anruflink oder eine Raum-ID ein (Buchstaben, Ziffern und Bindestriche)",
  guestTitle: "Sie sind zu einem Videoanruf eingeladen",
  guestBody: "Der Raum ist bereit. Ihr Gegenüber sieht Sie, sobald Sie beitreten.",
  guestJoin: "Beitreten",
  guestFreeNote: "Beitreten ist immer kostenlos",
  guestCreateOwn: "Eigenen Raum erstellen",
  guestInvalidTitle: "Dieser Link scheint defekt zu sein",
  guestInvalidBody: "Lassen Sie sich den Link noch einmal schicken oder erstellen Sie einen eigenen Raum.",
  inviteCardTitle: "Ihr Raum ist bereit",
  inviteCardBody: "Senden Sie den Link an die Person, mit der Sie sprechen möchten",
  inviteShareLink: "Link teilen",
  inviteCopy: "Kopieren",
  inviteBrowserHint: "Öffnet sich in jedem Browser. Die App muss nicht installiert werden.",
  inviteSentHint: "Gesendet? Ihr Gegenüber erscheint hier, sobald der Link geöffnet wird.",
  inviteShareMessage: "Komm in meinen Videoanruf auf One2One 👋\nÖffne einfach den Link. Er funktioniert im Browser, du musst nichts installieren:\n{link}",
  copyLink: "Link kopieren",
  consentBannerText: "Dürfen wir Nutzungsstatistiken erfassen? Sie zeigen uns, welche Funktionen genutzt werden. Anrufinhalte sind darin nie enthalten.",
  consentAllow: "Erlauben",
  consentDeny: "Nicht erlauben",
  privacySettingsLink: "Statistik-Einstellungen",
} as const;
